require('./bootstrap');
// Components

require('./components/ga_tracking');
require('./components/libsyn');
require('./components/utilities');
require('./components/filters');

// Blocks
require('./blocks/accordion');
require('./blocks/featured-posts');
require('./blocks/insightsAccordion');
require('./blocks/events');
require('./blocks/masthead');
require('./blocks/new-hires');
require('./blocks/responsive-slider');
require('./blocks/stats');
require('./blocks/tabs');
require('./blocks/ticker');

require('./pages/landing');
require('./pages/insights');

// Legacy
//require('./components/legacy');
